import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "expire-container"
};
const _hoisted_2 = {
  style: {
    "margin-top": "10px"
  }
};
import { findAppRecentExpirePage, findDongleRecentExpirePage, stopAppModule, stopDongleUserModule } from '@/api/expireRemind';
import { computed, ref, onMounted, watch } from 'vue';
import usePagination from '@/hooks/usePagination';
import Table from './components/table';
import { dongleUserTableScheme, authApplicationTableScheme } from './config';
import { ElMessageBox, ElMessage } from 'element-plus';
import DongleModuleCharge from './components/dongle-module-charge';
import AuthAppCharge from './components/auth-app-charge.vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const data = ref({
      keyword: '',
      type: 3,
      name: '',
      approvalStatus: '',
      applyStatus: ''
    });
    const scheme = computed(() => {
      return data.value.type === 3 ? dongleUserTableScheme : authApplicationTableScheme;
    });
    // 工作台跳转至本页面
    watch(() => router.currentRoute.value.path, toPath => {
      if (router.currentRoute.value.query.tab) {
        data.value.type = +router.currentRoute.value.query.tab;
      }
    }, {
      immediate: true,
      deep: true
    });
    // const searchHandle = (val) => {
    //   setCurrentPage(1)
    //   loadExpireData()
    // }

    const list = ref([]);
    const _findDongleRecentExpirePage = async () => {
      const res = await findDongleRecentExpirePage({
        keyword: data.value.keyword,
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        // name: data.value.name,
        moduleConfigName: data.value.name,
        approvalStatus: data.value.approvalStatus,
        applyStatus: data.value.applyStatus
      });
      list.value = res.records;
      setTotal(res.total);
    };
    const _findAppRecentExpirePage = async () => {
      const res = await findAppRecentExpirePage({
        keyword: data.value.keyword,
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        moduleConfigName: data.value.name,
        approvalStatus: data.value.approvalStatus,
        applyStatus: data.value.applyStatus,
        type: data.value.type === 3 ? '' : data.value.type
      });
      list.value = res.records;
      setTotal(res.total);
    };
    const loading = ref(false);
    const loadExpireData = async () => {
      loading.value = true;
      if (data.value.type === 3) {
        // 获取加密狗用户
        await _findDongleRecentExpirePage();
      } else {
        await _findAppRecentExpirePage();
      }
      loading.value = false;
    };
    onMounted(() => {
      loadExpireData();
    });
    const handleChangeTabs = e => {
      console.log(e);
      data.value.type = e;
      data.value.keyword = '';
      loadExpireData();
    };
    const handleCurrentChange = val => {
      setCurrentPage(val);
      loadExpireData();
    };
    const handleSearch = () => {
      setCurrentPage(1);
      loadExpireData();
    };
    const refreshData = () => {
      data.value.keyword = '';
      data.value.approvalStatus = '';
      data.value.applyStatus = '';
      data.value.name = '';
      setCurrentPage(1);
      loadExpireData();
    };
    const handleStop = row => {
      console.log(data.value.type);
      ElMessageBox.confirm(`确认停用该${data.value.type === 0 ? '加密狗应用' : '授权应用'}吗`, '温馨提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(async () => {
        if (data.value.type === 3) {
          await stopDongleUserModule({
            id: row.id,
            applyStatus: 2
          });
        } else {
          await stopAppModule({
            id: row.id,
            applyStatus: 2
          });
        }
        ElMessage.success('停用成功');
        loadExpireData();
      });
    };
    const handleOpen = row => {
      console.log(row);
      if (data.value.type === 3) {
        router.push(`/application/dongleUser/module/${row.userId}?dangUser=${row.name}`);
      } else if (data.value.type === 1) {
        router.push('/application/mobile');
      } else {
        router.push('/application/web');
      }
    };
    const current = ref(null);
    const dongleChargeVisible = ref(false);
    const appChargeVisible = ref(false);
    const handleCharge = row => {
      console.log(row);
      if (data.value.type === 0) {
        // 加密狗用户
        current.value = {
          ...row,
          applyApprovalType: 2
        };
        dongleChargeVisible.value = true;
        console.log(current.value, 'current');
      } else {
        // 应用
        current.value = {
          ...row
        };
        appChargeVisible.value = true;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: data.value.type,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.value.type = $event),
          type: "card",
          class: "demo-tabs",
          onTabChange: handleChangeTabs
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
            label: 'HIS应用',
            value: 3
          }, {
            label: '小程序应用',
            value: 1
          }, {
            label: 'Web应用',
            value: 2
          }], item => {
            return _createVNode(_component_el_tab_pane, {
              key: item.value,
              label: item.label,
              name: item.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_card, {
                shadow: "never",
                style: {
                  "border": "none"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form, {
                  inline: true,
                  model: data.value,
                  ref_for: true,
                  ref: "formEl"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    prop: "name",
                    label: data.value.type == 3 ? '加密狗编号' : '应用名称',
                    style: {
                      "margin-bottom": "0"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: data.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value.name = $event),
                      placeholder: `请输入${data.value.type == 3 ? '加密狗编号' : '应用名称'}`,
                      size: "default",
                      class: "input"
                    }, null, 8, ["modelValue", "placeholder"])]),
                    _: 1
                  }, 8, ["label"]), _createVNode(_component_el_form_item, {
                    prop: "applyStatus",
                    label: "应用状态",
                    style: {
                      "margin-bottom": "0"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_select, {
                      modelValue: data.value.applyStatus,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.value.applyStatus = $event),
                      style: {
                        "width": "200px"
                      }
                    }, {
                      default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                        label: '使用中',
                        value: 1
                      }, {
                        label: '停用',
                        value: 2
                      }], item => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 64))]),
                      _: 2
                    }, 1032, ["modelValue"])]),
                    _: 2
                  }, 1024), _createVNode(_component_el_form_item, {
                    prop: "keyword",
                    label: "租户/诊所",
                    style: {
                      "margin-bottom": "0"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: data.value.keyword,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.value.keyword = $event),
                      placeholder: "请输入租户/诊所名称",
                      size: "default",
                      class: "input"
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  }), _createVNode(_component_el_form_item, {
                    style: {
                      "margin-bottom": "0"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_button, {
                      type: "primary",
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => [_createTextVNode("查询")]),
                      _: 1
                    }), _createVNode(_component_el_button, {
                      onClick: refreshData
                    }, {
                      default: _withCtx(() => [_createTextVNode("重置")]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["model"])]),
                _: 2
              }, 1024), _createVNode(_component_el_card, {
                shadow: "never",
                style: {
                  "border": "none"
                }
              }, {
                default: _withCtx(() => [_createVNode(_unref(Table), {
                  scheme: scheme.value,
                  tableData: list.value,
                  loading: loading.value,
                  currentPage: _unref(currentPage),
                  pageSize: _unref(pageSize),
                  onStop: handleStop,
                  onCharge: handleCharge,
                  onOpen: handleOpen
                }, null, 8, ["scheme", "tableData", "loading", "currentPage", "pageSize"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
                  class: "pagination",
                  onCurrentChange: handleCurrentChange,
                  "current-page": _unref(currentPage),
                  "page-size": _unref(pageSize),
                  total: _unref(total),
                  layout: "total,  prev, pager, next, jumper"
                }, null, 8, ["current-page", "page-size", "total"])])]),
                _: 1
              })]),
              _: 2
            }, 1032, ["label", "name"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_unref(DongleModuleCharge), {
        onRefreshData: loadExpireData,
        onClearModel: _cache[4] || (_cache[4] = $event => current.value = null),
        model: current.value,
        modelValue: dongleChargeVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dongleChargeVisible.value = $event)
      }, null, 8, ["model", "modelValue"]), _createVNode(AuthAppCharge, {
        modelValue: appChargeVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => appChargeVisible.value = $event),
        model: current.value,
        onRefreshData: loadExpireData,
        onClearModel: _cache[7] || (_cache[7] = $event => current.value = null)
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};